export const PLAYER_FIELDS = [
  { field: "First Name", key: "firstName", input: "Text", example: "Jason" },
  { field: "Last Name", key: "lastName", input: "Text", example: "Rivera" },
  { field: "Position", key: "position", input: "Text", example: "1B/RHP" },
  { field: "Player Class", key: "playerClass", input: "Text", example: "FR" },
  { field: "School / College", key: "teamName", input: "Text", example: "Central Valley JC" },
  { field: "Height", key: "height", input: "Text", example: "6'0\"" },
  { field: "Weight", key: "weight", input: "Text", example: "200" },
  { field: "Bats / Throws", key: "batsThrows", input: "Text", example: "R/R" },
  { field: "Jersey Number", key: "jerseyNumber", input: "Text", example: "44" },
  { field: "High School", key: "highSchool", input: "Text", example: "CASS" },
  { field: "NCAA ID", key: "ncaaId", input: "Text", example: "12345678" },
  { field: "Hometown", key: "hometown", input: "Text", example: "Atlanta, GA" },
  { field: "Season Year", key: "seasonYear", input: "Text", example: "2025-26" },
  { field: "Commitment Status", key: "commitmentStatus", input: "Select", options: ["uncommitted", "committed"], example: "uncommitted" },
  { field: "Previous Teams", key: "previousTeams", input: "Text", example: "Team A, Team B, Team C" },
  {
    field: "Bio / Summary",
    key: "player_bio",
    input: "Textarea",
    example: "Short summary about player",
  },
];
